import React, { useCallback, useEffect, useState } from "react";
import {
  DOCUMENT_TYPES,
  fetchDocumentNumber,
  getDocumentConfig,
  MODIFICATION_TYPES,
  theme,
  tooltipContent,
} from "../config/DocumentConfig";
import { useLocation, useNavigate } from "react-router-dom";
import useApi from "../../hooks/useApi";
import { getTodayDate } from "../../utils/constants";
import { Box, IconButton, Tab, ThemeProvider, Tooltip } from "@mui/material";
import { HelpOutline } from "@mui/icons-material";
import { purchaseData, workOrderData } from "../salesInvoice/data";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import TimelineTab from "../salesInvoice/TimelineTab";
import { Loader, Printer, Save } from "lucide-react";
import WorkOrderGeneral from "./WorkOrderGeneral";
import PurchaseOrderTable from "../purchaseOrder/PurchaseOrderTable";
import SummaryTotalCard from "../salesInvoice/SummaryTotalCard";
import ConfigCard from "../salesInvoice/ConfigCard";
import WorkOrderTable from "./WorkOrdertable";
import {
  calculateWorkOrderRow,
  getWorkOrderVatPercent,
} from "../config/WorkOrderTableConfig";
import Modal from "../common/CommonModal";
import ModificationCommentModal from "../salesInvoice/ModificationCommentModal";

const WorkOrder = ({ documentType = DOCUMENT_TYPES.WORK_ORDER }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { request } = useApi();
  const config = getDocumentConfig(documentType);

  const DEPARTMENT =
    localStorage.getItem("currentSelectedDepartment") || "MAIN";
  const COMPANY_CODE = localStorage?.getItem("companyCode") || "DOODDEMO";
  const CURRENT_USER = localStorage?.getItem("currentUserName") || "admin";
  let API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  const CURRENT_USER_OBJECT = localStorage.getItem("currentUser")
    ? JSON.parse(localStorage.getItem("currentUser"))
    : "";
  const VATPERCENTAGE = CURRENT_USER_OBJECT[0]?.vatp;

  const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";
  const todayDate = getTodayDate();
  const documentNoFromState = location?.state?.docNo || null;
  const modeFromState = location?.state?.mode || "new";
  const [isSaving, setIsSaving] = useState(false);
  const [mode, setMode] = useState(modeFromState);
  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString()
  );
  const [parentTabValue, setParentTabValue] = useState("1");
  const [supplierData, setSupplierData] = useState(null);
  const [items, setItems] = useState(workOrderData);
  const [currentLocation, setCurrentLocation] = useState("MAIN SHOP");
  const [showSidebar, setShowSidebar] = useState(false);
  const [initialRowUnitOptions, setInitialRowUnitOptions] = useState({});

  const [discountAmount, setDiscountAmount] = useState("");
  const [roundOff, setRoundOff] = useState("");

  const [autoVatIsOn, setAutoVatIsOn] = useState(true);
  const [vatAmountManual, setVatAmountManual] = useState(null);
  const [transferModalOpen, setIsTransferModalOpen] = useState(false);
  const [isModificationModalOpen, setIsModificationModalOpen] = useState(false);

  const transferredData = location?.state?.transferredData || null;
  console.log("Transferred Data:", transferredData);
  const [fetchedSalesOrderData, setFetchedSalesOrderData] = useState(null);

  const handleParentTabChange = (event, newValue) => {
    setParentTabValue(newValue);
  };

  const [documentData, setDocumentData] = useState({
    documentNo: "",
    purchaseDate: new Date().toISOString().split("T")[0],
    soNo: "",
    soDate: "",
    quotationNo: "",
    leadNo: "",
    customerAccount: "",
    customerRef: "",
    customerName: "",
    tel: "",
    trn: "",
    creditLimit: 0,
    availableLimit: 0,
    paymentTerms: "",
    terms: "",
    delivery: "",
    lpo: "",
    remarks: "",
    areaCode: "",
    shipment: "",
    origin: "",
    currency: "AED",
    currencyRate: 1,
    discountAmount: 0,
    roundOff: 0,
    taxableAmount: 0,
    vatAmount: 0,
    grossAmount: 0,
    netAmount: 0,
    bcAmt: 0,
    vatStatus: "VAT Applied",
    vatPercent: VATPERCENTAGE,
    approval: "Pending",
    currentStatus: "Normal",
    salesPerson: "",
    salesPersonId: "",
  });
  const calculateTotals = () => {
    const round = (val) => Math.round(Number(val) * 100) / 100;

    const processedItems = items.map((item) =>
      calculateWorkOrderRow(item, documentData, {
        items,
      })
    );

    const rowTaxableSum = round(
      processedItems.reduce((sum, item) => sum + (Number(item.amount) || 0), 0)
    );

    const rowVatSum = round(
      processedItems.reduce(
        (sum, item) => sum + (Number(item.vatAmount) || 0),
        0
      )
    );
    const grossAmount = round(
      processedItems.reduce((sum, item) => sum + (Number(item.total) || 0), 0)
    );

    const globalDiscount = Number(discountAmount) || 0;
    const roundOffValue = Number(roundOff) || 0;

    const taxableAmount = round(rowTaxableSum - globalDiscount - roundOffValue);

    const totalVat =
      !autoVatIsOn && vatAmountManual !== null
        ? round(vatAmountManual)
        : rowVatSum;

    const totalAmount = round(taxableAmount + totalVat);

    const netAmount = round(totalAmount);

    const currencyRate = Number(documentData.currencyRate) || 1;
    const bcAmt = round(netAmount * currencyRate);

    return {
      grossAmount: grossAmount.toFixed(2),
      taxableAmount: taxableAmount.toFixed(2),
      vatAmount: totalVat.toFixed(2),
      discountAmount: globalDiscount.toFixed(2),
      roundOff: roundOffValue.toFixed(2),
      netAmount: netAmount.toFixed(2),
      // advanceAmount: advance.toFixed(2),
      bcAmt: bcAmt.toFixed(2),
    };
  };
  const totals = calculateTotals();

  const handleSave = async () => {
    try {
      setIsSaving(true);

      // Validate items
      const filteredItems = items.filter(
        (item) => item.code && item.code.trim() !== ""
      );

      if (filteredItems.length === 0) {
        alert("Please add at least one item to the work order");
        setIsSaving(false);
        return;
      }

      if (!documentData.customerAccount) {
        alert("Please select a customer/account");
        setIsSaving(false);
        return;
      }

      if (!documentData.soNo) {
        alert("Sales Order number is required");
        setIsSaving(false);
        return;
      }

      // Calculate totals before saving
      const round = (val) => Math.round(Number(val) * 100) / 100;

      // Map line items to payload format
      const lineItemsPayload = filteredItems.map((item, index) => ({
        Slno: index + 1,
        code: item.code || "",
        description: item.description || "",
        locn: item.location || "A",
        unit: item.unit || "PCS",
        qty: Number(item.qty) || 0,
        "Unit Price": Number(item.unitPrice) || 0,
        "Disc%": Number(item.discountPercent) || 0,
        Ldisc_amt:
          Number(item.qty) *
            Number(item.unitPrice) *
            (Number(item.discountPercent) / 100) || 0,
        Amount: Number(item.amount) || 0,
        x: "",
        cntrl: item.soUid || "",
        Fraction: item.fraction || "1",
        "vat%": Number(item.vatPercent) || 5,
        "Unit Cost": "0",
        dono: "0",
        sono: "0",
        leadno: "0",
        Avlqty: "0",
        Vatamt: Number(item.vatAmount) || 0,
        BDiscsplit: "0",
        total: Number(item.total) || 0,
        oem: item.oem || "",
        Bin: "",
        rcvd_mode1: "",
        rcvd_mode1_acc: "",
        rcvd_mode1_amt: 0,
        rcvd_mode2: "",
        rcvd_mode2_acc: "",
        rcvd_mode2_amt: 0,
        commi_acc_Dr: "",
        commi_acc_Cr: "",
        commi_amt: 0,
        shipping_type: "Shipping Charges",
        shipping_amt: 0,
      }));

      const masterPayload = {
        cmpcode: COMPANY_CODE,
        modeop: mode === "edit" ? "EDIT" : "SAVE",
        cashcustomer: "no",
        so_no: documentData.soNo || "",
        cust_acc: documentData.customerAccount || "",
        so_total: totals.netAmount || "0",
        so_cost: "0",
        jv_num: "",
        comments: documentData.remarks || "",
        disc_amt: documentData.discountAmount || "0",
        sale_man: documentData.salesPerson || "",
        lpo_no: documentData.lpo || "1",
        inv_no: "0",
        due_date: documentData.purchaseDate || todayDate,
        area_code: documentData.areaCode || "",
        type: "",
        do_data: "",
        q_no: documentData.quotationNo || "0",
        inv_type: "",
        user_id: CURRENT_USER,
        fdisc_amt: "0",
        costc: "",
        job_code: "",
        so_fctota: totals.netAmount || "0",
        fc: documentData.currency || "AED",
        awb: "",
        blno: "",
        pkg: "",
        rate2: "0",
        rate: Number(documentData.currencyRate) || 1,
        invcurr: "",
        supl_code: "",
        status: "",
        tr_refno: "",
        payment: documentData.paymentTerms || "credit",
        manuf: "",
        origin: documentData.origin || "",
        shipment: documentData.shipment || "",
        delivery: documentData.delivery || "",
        packing: "",
        netwt: "",
        grosswt: "",
        insurance: "",
        custom: "",
        validity: "",
        foot1: documentData.delivery || "",
        frdet: "",
        fruprice: "0",
        framt: "0",
        fob: "",
        repeat: "",
        comm: "0",
        date_paid: documentData.purchaseDate || todayDate,
        commdue: "0",
        comm_paid: "0",
        commp: "0",
        type_no: "0",
        paid_amt: "0",
        client_pd: "",
        tel: documentData.tel || "",
        custref: documentData.customerName || "",
        terms: documentData.soNo || "0",
        deptno: DEPARTMENT,
        month: "",
        cashcred: "",
        so_date: documentData.soDate || todayDate,
        qo_no: documentData.quotationNo || "0",
        sys_date: todayDate,
        comm_pd_dt: documentData.purchaseDate || todayDate,
        pump: "",
        governor: "",
        feedpump: "",
        injector: "",
        starter: "",
        enginetype: documentData.vatStatus === "VAT Applied" ? "CASH" : "VAT",
        date_prom: documentData.purchaseDate || todayDate,
        date_delvd: documentData.purchaseDate || todayDate,
        inv_qty: 0,
        rcvd_amt: "0",
        time: "",
        lab_charge: "0",
        oth_charge: 0,
        s: "",
        m: "0",
        d: "0",
        e: "0",
        w: "0.05",
        wa: "0",
        pgroup: "",
        upd: "",
        inv_date: documentData.purchaseDate || todayDate,
        lpo_date: documentData.purchaseDate || todayDate,
        vehicleno: "",
        drivername: "",
        deliv_site: "",
        head1: "",
        cap: "",
        salesacc: "",
        salesAccDesc: "",
        ...(lineItemsPayload.length > 0 ? lineItemsPayload[0] : {}),
      };

      const finalPayload = [masterPayload, ...lineItemsPayload.slice(1)];

      console.log("Payload to save:", finalPayload);
      const apiUrl = `${BASE_URL}${config.apiEndpoints.save}`;

      const response = await request({
        url: apiUrl,
        method: "POST",
        data: finalPayload,
        timeout: 10000,
      });

      console.log("API Response:", response);

      if (response && response.result === "Saved" && response.woNo) {
        const woNumber = response.woNo;
        alert(`Work Order #${woNumber} saved successfully!`);

        navigate("/distribution_dashboard");
      } else if (response && response.result) {
        alert(`Work Order saved successfully!`);
        navigate("/distribution_dashboard");
      } else {
        alert(
          `Failed to save Work Order: ${response?.message || "Unknown error"}`
        );
      }
    } catch (error) {
      console.error("Error saving Work Order:", error);
      alert("Error saving Work Order: " + error.message);
    } finally {
      setIsSaving(false);
    }
  };
  const handlePrint = () => {};

  useEffect(() => {
    if (transferredData?.master) {
      const masterData = transferredData.master;

      // Use a function to avoid stale closure
      setDocumentData((prev) => ({
        ...prev,
        customerAccount: masterData.cust_acc,
        customerRef: masterData.accdesc,
        customerName: masterData.accdesc,
        paymentTerms: masterData.payment,
        salesPerson: masterData.sale_man,
        soNo: masterData.so_no,
        quotationNo: masterData.qtn_no,
        soDate: masterData.so_date,
        currency: masterData.fc,
        currencyRate: Number(masterData.rate) || 1,
        discountAmount: Number(masterData.disc_amt) || 0,
        areaCode: masterData.area_code,
        shipment: masterData.shipment,
      }));

      // Auto-fill items from transferred data with unique IDs for DataGrid
      if (transferredData.items && transferredData.items.length > 0) {
        const mappedItems = transferredData.items.map((item, index) => ({
          id: Date.now() + index,
          sino: index + 1,
          code: item.so_icode,
          description: item.idesc,
          qty: Number(item.qty) || 0,
          unit: item.unit || "PCS",
          unitPrice: Number(item.so_fccost) || 0,
          lineTotal: Number(item.Amount) || 0,
          vatPercent: Number(item["vat%"]) || 5,
          location: item.locn || "",
          discount: Number(item.discount) || 0,
          fraction: item.fraction || "1",
          soUid: item.soUid || "",
        }));
        setItems(mappedItems);
      }

      setFetchedSalesOrderData(masterData);
    }
  }, [transferredData]);

  const initializeDocument = useCallback(async () => {
    try {
      const { voucherType, documentNo } = await fetchDocumentNumber(
        documentType,
        documentData.paymentMode,
        BASE_URL,
        COMPANY_CODE,
        DEPARTMENT
      );

      if (documentNo) {
        setDocumentData((prev) => ({
          ...prev,
          documentNo: documentNo,
          voucherType,
        }));
      }
      console.log("Voucher Type:", voucherType, documentNo);
    } catch (err) {
      console.error("Error initializing document:", err);
    }
  }, [
    documentType,
    documentData?.paymentMode,
    BASE_URL,
    COMPANY_CODE,
    DEPARTMENT,
  ]);

  const fetchWorkOrderDetail = async (woNo) => {
    try {
      const url = config.apiEndpoints.detail(COMPANY_CODE, woNo, DEPARTMENT);
      const fullUrl = `${BASE_URL}${url}`;

      const response = await request({ url: fullUrl, method: "GET" });

      if (!response || response.length === 0) {
        alert("Work Order not found");
        return;
      }

      const header = response[0];
      console.log("Fetched Work Order Detail:", header);

      // Auto-fill master/header data
      setDocumentData((prev) => ({
        ...prev,
        documentNo: String(header.so_no || ""),
        purchaseDate: header.so_date
          ? header.so_date.slice(0, 10)
          : prev.purchaseDate,
        soNo: header.so_no || "",
        soDate: header.so_date ? header.so_date.slice(0, 10) : "",
        quotationNo: header.qo_no || header.quotno || "0",
        leadNo: header.leadno || "",
        customerAccount: header.cust_acc || "",
        customerRef: header.accdesc || "",
        customerName: header.accdesc || "",
        tel: header.tel || "",
        trn: header.CCNO || "",
        paymentTerms: header.payment || "",
        terms: header.payment || "",
        delivery: header.foot1 || "",
        lpo: header.lpo_no || "",
        remarks: header.comments || "",
        areaCode: header.area_code || "",
        shipment: header.shipment || "",
        origin: header.origin || "",
        currency: header.fc || "AED",
        currencyRate: Number(header.rate) || 1,
        discountAmount: Number(header.disc_amt) || 0,
        vatStatus: header.vat_status || "VAT Applied",
        salesPerson: header.sale_man || "",
      }));

      // Auto-fill line items
      const mappedItems = response.map((row, index) => ({
        id: index + 1,
        sino: index + 1,
        code: row.so_icode || "",
        description: row.idesc || "",
        qty: Number(row.so_qty) || 0,
        unit: row.unit || "PCS",
        unitPrice: Number(row.so_fccost) || 0,
        discountPercent: Number(row.discount) || 0,
        amount: Number(row.amount) || 0,
        fraction: row.fraction || "1",
        vatPercent: Number(row["vat%"]) || 5,
        vatAmount: Number(row.vatamt) || 0,
        total: Number(row.total) || 0,
        location: row.locn || "A",
        oem: row.oem || "",
        qno: row.qno || "",
        soUid: row.soUid || "",
      }));

      setItems(mappedItems);
      setFetchedSalesOrderData(header);
    } catch (error) {
      console.error("Error fetching Work Order detail:", error);
      alert("Failed to load Work Order details: " + error.message);
    }
  };

  useEffect(() => {
    if (documentNoFromState && mode === "edit") {
      fetchWorkOrderDetail(documentNoFromState);
    }
  }, [documentNoFromState, mode]);

  useEffect(() => {
    if (mode === "new") {
      // ensure paymentMode exists
      initializeDocument();
    }
  }, [mode, initializeDocument]);

  // Populate supplier data when fetchedSalesOrderData changes
  useEffect(() => {
    if (fetchedSalesOrderData?.cust_acc) {
      setSupplierData({
        account: fetchedSalesOrderData.cust_acc,
        name: fetchedSalesOrderData.custref,
        tel: fetchedSalesOrderData.tel,
      });
    }
  }, [fetchedSalesOrderData]);
  return (
    <div className="w-full relative">
      <div className="flex items-center justify-between lg:px-10 px-2 mb-2 gap-2">
        <div className="flex items-center gap-3">
          <h1 className="text-xl font-semibold">{config.title}</h1>
        </div>

        <Tooltip title={tooltipContent} sx={{ margin: 0, padding: 0 }}>
          <IconButton>
            <HelpOutline
              className="text-blue-600 bg-white rounded-full"
              fontSize="medium"
            />
          </IconButton>
        </Tooltip>
      </div>
      <div className="w-full rounded-lg">
        <div className="lg:px-10">
          <div className="bg-gray-50 border lg:p-3 rounded-lg shadow pb-6">
            <ThemeProvider theme={theme}>
              <TabContext value={parentTabValue}>
                <Box
                  sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <TabList onChange={handleParentTabChange}>
                    <Tab label="General" value="1" sx={{ padding: 0 }} />
                    {/* <Tab label="Shipping" value="2" sx={{ padding: 0 }} /> */}
                    <Tab label="Timeline" value="2" sx={{ padding: 0 }} />
                  </TabList>
                  <div className="lg:flex hidden items-center gap-3">
                    <button
                      //   onClick={handlePrint}
                      disabled={mode === "view"}
                      className="flex items-center gap-2 px-5 py-2.5 border border-indigo-600 text-indigo-600 text-sm font-medium rounded-lg shadow hover:text-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <Printer className="w-4 h-4" />
                      Print
                    </button>
                    <button
                      onClick={() => {
                        if (mode === "edit") {
                          setIsModificationModalOpen(true);
                        } else {
                          handleSave();
                        }
                      }}
                      disabled={mode === "view" || isSaving}
                      className="flex items-center gap-2 px-5 py-2.5 bg-green-500 text-white text-sm font-medium rounded-lg shadow hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-400 transition disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {isSaving ? (
                        <>
                          <Loader className="w-4 h-4 animate-spin" />
                          Saving...
                        </>
                      ) : (
                        <>
                          <Save className="w-4 h-4" />
                          {mode === "edit" ? "Update" : "Save"}
                        </>
                      )}
                    </button>
                  </div>
                </Box>
                <TabPanel value="1" sx={{ p: 0, paddingX: 0 }}>
                  <WorkOrderGeneral
                    WorkOrderData={documentData}
                    setWorkOrderData={setDocumentData}
                  />
                </TabPanel>
                {/* <TabPanel value="2" sx={{ p: 0, paddingX: 0 }}>
                  Tab 2
                </TabPanel> */}
                <TabPanel value="2" sx={{ p: 1 }}>
                  <TimelineTab
                    BASE_URL={BASE_URL}
                    DEPARTMENT={DEPARTMENT}
                    modificationType={MODIFICATION_TYPES[documentType] || null}
                    invoiceId={documentNoFromState}
                    COMPANY_CODE={COMPANY_CODE}
                  />
                </TabPanel>
              </TabContext>
            </ThemeProvider>
          </div>
        </div>
        <main className="w-full mt-4 relative">
          <WorkOrderTable
            items={items}
            onItemsChange={setItems}
            setShowSidebar={setShowSidebar}
            // setItemInfo={setItemInfo}
            setCurrentLocation={setCurrentLocation}
            extraFields={[]}
            purchaseData={documentData}
            initialRowUnitOptions={initialRowUnitOptions}
            setInitialRowUnitOptions={setInitialRowUnitOptions}
            // isOtherCostEnabled={false}
            // setIsOtherCostEnabled={setIsOtherCostEnabled}
            // otherCosts={otherCosts}
            // setOtherCosts={setOtherCosts}
            calculateWorkOrderRow={calculateWorkOrderRow}
            invoiceData={documentData}
            getVatPercent={getWorkOrderVatPercent}
            BASE_URL={BASE_URL}
            COMPANY_CODE={COMPANY_CODE}
            DEPARTMENT_NO={DEPARTMENT}
          />
        </main>
        <div className="w-full lg:px-10 p-1 mt-2">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-start">
            <ConfigCard
              invoiceData={documentData}
              setAutoVatIsOn={setAutoVatIsOn}
              setInvoiceData={setDocumentData}
              autoVatIsOn={autoVatIsOn}
              documentType={documentType}
              config={config}
              setIsModalOpen={setIsTransferModalOpen}
              isModalOpen={transferModalOpen}
              // fetchDocumentDetail={fetchDocumentDetail}
              invoiceNoFromState={documentNoFromState}
              accountData={supplierData}
              // onTransfer={handltr}
            />

            <SummaryTotalCard
              totals={totals}
              setInvoiceData={setDocumentData}
              invoiceData={documentData}
              handlePrint={handlePrint}
              handleSave={handleSave}
              roundOff={roundOff}
              setRoundOff={setRoundOff}
              discountAmount={discountAmount}
              setDiscountAmount={setDiscountAmount}
              mode={mode}
              autoVatIsOn={autoVatIsOn}
              setVatAmountManual={setVatAmountManual}
              config={config}
              setIsModificationModalOpen={setIsModificationModalOpen}
            />
          </div>
        </div>
      </div>
      <Modal
        isOpen={isModificationModalOpen}
        onClose={() => setIsModificationModalOpen(false)}
        size="md"
        header={true}
        title="Update Confirmation"
        showFullScreen={false}
      >
        <ModificationCommentModal
          isOpen={isModificationModalOpen}
          onClose={() => setIsModificationModalOpen(false)}
          handleSave={handleSave}
          documentData={documentData}
          documentType={documentType}
          COMPANY_CODE={COMPANY_CODE}
          DEPARTMENT={DEPARTMENT}
          CURRENT_USER={CURRENT_USER}
          BASE_URL={BASE_URL}
          setIsModificationModalOpen={setIsModificationModalOpen}
        />
      </Modal>
    </div>
  );
};

export default WorkOrder;
